export default __webpack_public_path__ + "static/media/africa-countries.062003e4.jpeg";